import { render } from "./HoursColumn.vue?vue&type=template&id=524b2f81&scoped=true"
import script from "./HoursColumn.vue?vue&type=script&lang=js"
export * from "./HoursColumn.vue?vue&type=script&lang=js"

import "./HoursColumn.vue?vue&type=style&index=0&id=524b2f81&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524b2f81"]])

export default __exports__